import React from 'react';

import Badge, {BadgeColor} from 'ui-library/Badge';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

/**
 * Badge shown above the plate grid while an AI-suggested role layout is being previewed.
 */
export default function AISuggestedLayoutBadge(): JSX.Element {
  return (
    <Badge color={BadgeColor.PURPLE} bold={true}>
      <BenchlingIcon icon="sparkle" color="purple" style={{marginRight: 6}} />
      Suggested Layout
    </Badge>
  );
}
